import {BaseStorage} from '@fantasmagames/slot/src/logic/Storage';

export class RelaxStorage extends BaseStorage {
	public setItem(key: string, data: string): void {}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/logic/relax/RelaxStorage.ts